export var filterOutrightSelections = function (selections) {
    var activeSelection = selections.filter(function (s) { return !s.isDisabled; });
    return activeSelection.filter(function (s) { return s.tags && s.tags.indexOf("Place") < 0; });
};
//# sourceMappingURL=filterOutrightSelections.js.map